/**
 * Carrying the session JWT into a WebSocket handshake without putting it in the URL.
 *
 * A handshake is an ordinary HTTP GET, so `?token=<jwt>` wrote the widest
 * credential this system has into browser history, `Referer`, every
 * intermediary, and — since WI 3c4834eb — the ALB and CloudFront access logs at
 * 90-day retention. A browser cannot set a custom header on a socket, but it CAN
 * offer subprotocols, and `Sec-WebSocket-Protocol` is a header no access-log
 * field set records.
 *
 * So every socket here offers two values: this sentinel, followed by the token.
 * The server lifts the value after the sentinel and echoes back the sentinel
 * alone. Both are opaque RFC 6455 tokens — a JWT is base64url plus dots, all
 * legal — so nothing needs escaping.
 *
 * Backend counterpart: `shared/auth/websocket_token.py`
 * (`WS_AUTH_SUBPROTOCOL` / `extract_handshake_token`).
 */

/** Offered immediately before the credential in `Sec-WebSocket-Protocol`. */
export const WS_AUTH_SUBPROTOCOL = 'panluma.auth.bearer';

/**
 * The `protocols` argument for `new WebSocket(url, …)`.
 *
 * Order matters: the server reads the value that FOLLOWS the sentinel.
 */
export function wsAuthProtocols(token: string): string[] {
  return [WS_AUTH_SUBPROTOCOL, token];
}
